"use client";

import Image from "next/image";
import { useState, useEffect } from "react";

export default function FeatureListItem({ icon, text, description, isActive, onClick, image }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <li className="group">
      <div onClick={onClick} className="relative flex cursor-pointer items-center border-b border-black pb-4 dark:border-gray-700">
        <div
          className={`absolute left-0 h-12 w-12 transition-opacity duration-200 ${
            isActive || isMobile ? "opacity-100" : "opacity-0 lg:group-hover:opacity-100"
          }`}
        >
          <div className="relative h-12 w-12">
            <Image src={icon} alt="" fill className="object-contain" sizes="48px" priority />
          </div>
        </div>
        <h1
          className={`relative block font-questrial text-2xl font-bold transition-all duration-200 ${
            isActive || isMobile ? "pl-16" : "pl-0 lg:group-hover:pl-16"
          }`}
        >
          {text}
        </h1>
      </div>
      <div
        className={`overflow-hidden font-questrial transition-all duration-300 ${
          isActive ? "max-h-48 pb-8 pt-4 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <p className="font-questrial text-2xl text-black">{description}</p>
      </div>
      {/* Mobile image */}
      {isActive && isMobile && (
        <div className="mt-4 block w-full md:hidden">
          <img src={image} alt={text} className="animate-fadeIn w-full object-cover" style={{ width: "150vw" }} />
        </div>
      )}
    </li>
  );
}
